<template>
    <div class="detail-container">
        <!-- 审核中遮罩层 -->
        <div v-if="isReviewing" class="review-mask">
            <div class="review-text">认证审核中，请耐心等待</div>
        </div>

        <!-- 原有内容 -->
        <div :class="{ 'disabled-content': isReviewing }">

            <!-- 顶部标题栏 -->
            <div class="page-header" v-if="currentName === ''">
                <div class="page-title">
                    <span class="title-bar"></span>
                    企业信息管理
                </div>
                <el-button type="primary" size="small" icon="el-icon-edit"
                    @click="changeName('DetailModify', activity.socialCreditCode)">
                    修改企业信息
                </el-button>
            </div>

            <!-- 基本信息 -->
            <el-card shadow="never" class="section-card" v-if="currentName === ''">
                <div slot="header" class="card-header">
                    <span class="card-header-title"><i class="el-icon-office-building"></i> 基本信息</span>
                    <span class="auth-badge"
                        :class="activity.authState === '认证成功' ? 'auth-ok' : 'auth-pending-badge'">
                        <i :class="activity.authState === '认证成功' ? 'el-icon-circle-check' : 'el-icon-warning-outline'"></i>
                        {{ activity.authState === '认证成功' ? '已认证' : '未认证' }}
                    </span>
                </div>
                <div class="info-body">
                    <div class="logo-col">
                        <el-upload class="avatar-uploader" :http-request="uploadFile" accept=".jpg, .png"
                            action="" :show-file-list="false" :before-upload="beforeAvatarUpload">
                            <img v-if="activity.companyLogo" :src="activity.companyLogo" class="company-logo-img" />
                            <div v-else class="logo-placeholder">
                                <i class="el-icon-plus"></i>
                                <div>上传Logo</div>
                            </div>
                        </el-upload>
                    </div>
                    <div class="info-fields">
                        <div class="field-item">
                            <div class="field-label">企业名称</div>
                            <div class="field-value">{{ activity.companyName }}</div>
                        </div>
                        <div class="field-item">
                            <div class="field-label">统一信用代码</div>
                            <div class="field-value mono">{{ activity.socialCreditCode }}</div>
                        </div>
                        <div class="field-item">
                            <div class="field-label">企业类型</div>
                            <div class="field-value">{{ activity.companyType }}</div>
                        </div>
                        <div class="field-item">
                            <div class="field-label">成立日期</div>
                            <div class="field-value">{{ activity.setUpTime }}</div>
                        </div>
                    </div>
                </div>
            </el-card>

            <!-- 注册信息 -->
            <el-card shadow="never" class="section-card" v-if="currentName === ''">
                <div slot="header" class="card-header">
                    <span class="card-header-title"><i class="el-icon-document"></i> 注册信息</span>
                </div>
                <div class="field-grid">
                    <div class="field-item">
                        <div class="field-label">注册资金（人民币）</div>
                        <div class="field-value">{{ activity.registeredCapital }}</div>
                    </div>
                    <div class="field-item">
                        <div class="field-label">法定代表人</div>
                        <div class="field-value">{{ activity.legalPerson }}</div>
                    </div>
                    <div class="field-item">
                        <div class="field-label">营业期限</div>
                        <div class="field-value">{{ activity.operatingPeriod }}</div>
                    </div>
                    <div class="field-item full-width">
                        <div class="field-label">注册地址</div>
                        <div class="field-value">{{ activity.registeredAddress }}</div>
                    </div>
                    <div class="field-item full-width">
                        <div class="field-label">经营范围</div>
                        <div class="field-value">{{ activity.businessNature }}</div>
                    </div>
                </div>
            </el-card>

            <!-- 财务信息 -->
            <el-card shadow="never" class="section-card" v-if="currentName === ''">
                <div slot="header" class="card-header">
                    <span class="card-header-title"><i class="el-icon-bank-card"></i> 财务信息</span>
                </div>
                <div class="field-grid">
                    <div class="field-item">
                        <div class="field-label">开户银行</div>
                        <div class="field-value">{{ activity.accountBankName }}</div>
                    </div>
                    <div class="field-item">
                        <div class="field-label">对公账号</div>
                        <div class="field-value mono">{{ activity.accountCode }}</div>
                    </div>
                    <div class="field-item">
                        <div class="field-label">对公账户名称</div>
                        <div class="field-value">{{ activity.companyName }}</div>
                    </div>
                </div>
            </el-card>

            <!-- 联系人信息 -->
            <el-card shadow="never" class="section-card" v-if="currentName === ''">
                <div slot="header" class="card-header">
                    <span class="card-header-title"><i class="el-icon-user"></i> 联系人信息</span>
                </div>
                <div class="field-grid">
                    <div class="field-item">
                        <div class="field-label">联系人姓名</div>
                        <div class="field-value">{{ activity.contactsName }}</div>
                    </div>
                    <div class="field-item">
                        <div class="field-label">联系人电话</div>
                        <div class="field-value">{{ activity.contactsPhone }}</div>
                    </div>
                    <div class="field-item">
                        <div class="field-label">联系人邮箱</div>
                        <div class="field-value">{{ activity.contactsEmail }}</div>
                    </div>
                </div>
            </el-card>

            <!-- 企业证件信息 -->
            <el-card shadow="never" class="section-card" v-if="currentName === ''">
                <div slot="header" class="card-header">
                    <span class="card-header-title"><i class="el-icon-picture-outline"></i> 企业证件信息</span>
                </div>
                <div class="doc-grid">
                    <div class="doc-item" @click="handlePictureCardPreview(activity.businessLicense)">
                        <div class="doc-img-wrap">
                            <img :src="activity.businessLicense" alt="营业执照" class="doc-img" />
                            <div class="doc-overlay"><i class="el-icon-zoom-in"></i></div>
                        </div>
                        <div class="doc-label">营业执照</div>
                    </div>
                    <div class="doc-item" @click="handlePictureCardPreview(activity.legalPersonIdCardFront)">
                        <div class="doc-img-wrap">
                            <img :src="activity.legalPersonIdCardFront" alt="身份证正面" class="doc-img" />
                            <div class="doc-overlay"><i class="el-icon-zoom-in"></i></div>
                        </div>
                        <div class="doc-label">法人身份证（正面）</div>
                    </div>
                    <div class="doc-item" @click="handlePictureCardPreview(activity.legalPersonIdCardBack)">
                        <div class="doc-img-wrap">
                            <img :src="activity.legalPersonIdCardBack" alt="身份证背面" class="doc-img" />
                            <div class="doc-overlay"><i class="el-icon-zoom-in"></i></div>
                        </div>
                        <div class="doc-label">法人身份证（背面）</div>
                    </div>
                </div>
            </el-card>

            <el-dialog :visible.sync="dialogVisible" width="60%">
                <img width="100%" :src="dialogImageUrl" alt="证件预览">
            </el-dialog>

            <!-- 修改模式标题栏 -->
            <div class="page-header" v-if="currentName !== ''">
                <div class="page-title">
                    <span class="title-bar"></span>
                    企业信息管理
                </div>
                <el-button type="danger" size="small" icon="el-icon-arrow-left" @click="changeName('')">
                    返回企业详情
                </el-button>
            </div>

            <component :is="currentName" :socialCreditCode="socialCreditCodeToPass" @changeName="changeName">
            </component>

        </div>
    </div>
</template>

<script>
import DetailModify from "../../views/company/DetailModify";

export default {
    name: "PublishBoard",
    data() {
        return {
            boardsTotal: 1,
            currPage: 1,
            keywords: "",
            currentName: "",
            tableData: [],
            columnWidth: 180,
            activeTab: "教务通知公告",
            userInfo: "",
            role: "",
            avatarUrl: "",
            city: "",
            position: {
                city: "",
                province: "",
            },
            orgOptions: {},
            noticeContent_1: [],
            noticeContent_2: [],
            currPage1: 1,
            currPage2: 1,
            hasNextPage1: false,
            hasPrePage1: false,
            hasNextPage2: false,
            hasPrePage2: false,

            socialCreditCodeToPass: "",
            dialogVisible: false,
            dialogImageUrl: "",
            isReviewing: false, // 审核状态标志
            activity: {
                companyName: "",
                companyLogo: "",
                socialCreditCode: "",
                companyType: "",
                registeredCapital: "",
                registeredAddress: "",

                legalPerson: "",
                setUpTime: "",
                businessTime: "",

                accountBankName: "",
                accountName: "",
                accountCode: "",

                contactsName: "",
                contactsPhone: "",
                contactsEmail: "",

                registeredAddress: "",
                businessNature: "",

                color: "#00bcd4",
                businessLicense: "",
            },
        };
    },
    components: {
        DetailModify,
    },
    watch: {},
    mounted() {
        this.initDetailInfo("");

    },
    methods: {
        handleCurrentChange(val) {
            this.currPage = val;
        },

        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 1;

            if (!isJPG && !isPNG) {
                this.$message.error("上传Logo图片只能是 jpg/png 的格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传Logo图片大小不能超过 1MB!");
            }
            return (isJPG || isPNG) && isLt2M;
        },
        uploadFile(file) {



            let user = JSON.parse(window.localStorage.getItem('user'));

            let formData = new FormData();
            formData.append("avatar", file.file);
            formData.append("userId", user.id);
            //传入其他的参数
            this.postFileRequest("/web/companyInfo/updateLogo", formData)
                .then((response) => {
                    this.activity.companyLogo = response.data.object.imageUrl;
                })
                .catch((error) => {
                    this.$message.error("上传失败，请稍后重试...");
                });
        },
        initDetailInfo(keyword) {
            let user = JSON.parse(window.localStorage.getItem('user'));
            //console.log("useid:  " + user.id)

            this.getRequest(
                "/web/companyDetail/query?userId=" + user.id
            ).then((resp) => {
                //console.log(resp.data.socialcreditcode);
                if (resp) {


                    // 检查认证状态
                    if (resp.data.authState !== "认证成功" & resp.data.authState !== "认证驳回") {
                        if (resp.data.authState !== "认证中") {
                            this.$confirm('企业信息未认证，请先进行认证！', '提示', {
                                confirmButtonText: '去认证',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.$router.push('/home');
                            }).catch(() => {
                                this.$router.push('/home');
                            });
                            return;
                        }


                    }

                    // 检查审核状态
                    if (resp.data.authState === "认证中") {
                        this.isReviewing = true;
                    } else {
                        this.isReviewing = false;
                    }


                    this.activity = resp.data;
                    this.getBusinessLicense();
                    this.getLegalPersonIdCardFront();
                    this.getLegalPersonIdCardBack();
                }
            });
        },

        getBusinessLicense() {
            this.axios.get('/web/images/get?type=businessLicense', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.activity.businessLicense = imageUrl;
            }).catch(error => {
                console.error('获取营业执照失败:', error);
                this.$message.error('获取营业执照失败');
            });
        },

        handlePictureCardPreview(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true;
        },

        getLegalPersonIdCardFront() {
            this.axios.get('/web/images/get?type=legalPersonIdCardFront', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.activity.legalPersonIdCardFront = imageUrl;
            }).catch(error => {
                console.error('获取法人身份证失败:', error);
                this.$message.error('获取法人身份证失败');
            });
        },


        getLegalPersonIdCardBack() {
            this.axios.get('/web/images/get?type=legalPersonIdCardBack', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.activity.legalPersonIdCardBack = imageUrl;
            }).catch(error => {
                console.error('获取法人身份证失败:', error);
                this.$message.error('获取法人身份证失败');
            });
        },





        changeName(name, socialCreditCode = "") {
            //console.log(this.currentName);
            this.currentName = name;
            this.socialCreditCodeToPass = socialCreditCode;
            if (name === "") {
                this.$store.commit("REMOVE_CURRENT_BOARD_ID");
            }
        },
        handleEdit(obj) {
            this.currentName = "AddBoardContent";
            this.$store.commit("ADD_CURRENT_BOARD_ID", obj.id);
        },

        publishedSwitch(obj) {
            this.getRequest(
                "/web/changeBoard/published?id=" +
                obj.id +
                "&published=" +
                obj.published
            ).then((resp) => { });
        },
    },
};
</script>

<style scoped>
.detail-container {
    padding: 24px 32px;
    min-height: calc(100vh - 60px);
    box-sizing: border-box;
    position: relative;
}

/* 遮罩 */
.disabled-content {
    pointer-events: none;
    opacity: 0.5;
}
.review-mask {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.review-text {
    font-size: 28px;
    font-weight: bold;
    color: #fff;
    background: rgba(230, 162, 60, 0.9);
    padding: 20px 48px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.3);
    letter-spacing: 2px;
}

/* 顶部标题栏 */
.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 16px 20px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 6px rgba(0,0,0,0.06);
}
.page-title {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    color: #1a1a2e;
    gap: 10px;
}
.title-bar {
    display: inline-block;
    width: 4px;
    height: 20px;
    background: linear-gradient(180deg, #274b86, #409EFF);
    border-radius: 2px;
}

/* section 卡片 */
.section-card {
    margin-bottom: 16px;
    border-radius: 10px;
    border: none;
    box-shadow: 0 1px 6px rgba(0,0,0,0.06);
}

/* 卡片头 */
.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.card-header-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    display: flex;
    align-items: center;
    gap: 6px;
}
.card-header-title i {
    color: #409EFF;
    font-size: 16px;
}

/* 认证徽标 */
.auth-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
}
.auth-ok {
    background: rgba(103,194,58,0.12);
    color: #67C23A;
    border: 1px solid rgba(103,194,58,0.3);
}
.auth-pending-badge {
    background: rgba(230,162,60,0.12);
    color: #e6a23c;
    border: 1px solid rgba(230,162,60,0.3);
}

/* 基本信息布局 */
.info-body {
    display: flex;
    align-items: flex-start;
    gap: 32px;
    padding: 8px 0;
}
.logo-col {
    flex-shrink: 0;
}
.company-logo-img {
    width: 90px;
    height: 90px;
    border-radius: 8px;
    border: 1px solid #ebeef5;
    object-fit: cover;
}
.logo-placeholder {
    width: 90px;
    height: 90px;
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 12px;
    cursor: pointer;
    gap: 6px;
}
.logo-placeholder i { font-size: 22px; }
.logo-placeholder:hover { border-color: #409EFF; color: #409EFF; }

.info-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 24px 48px;
    flex: 1;
}

/* 字段网格（其他卡片用） */
.field-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px 48px;
    padding: 4px 0;
}

/* 字段条目 */
.field-item {
    min-width: 180px;
}
.field-item.full-width {
    width: 100%;
    flex: none;
}
.field-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
    font-weight: 500;
}
.field-value {
    font-size: 15px;
    color: #1a1a2e;
    font-weight: 600;
    word-break: break-all;
}
.field-value.mono {
    font-family: 'Courier New', monospace;
    letter-spacing: 0.5px;
}

/* 证件图片 */
.doc-grid {
    display: flex;
    gap: 24px;
    padding: 8px 0;
    flex-wrap: wrap;
}
.doc-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}
.doc-img-wrap {
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #ebeef5;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08);
    transition: box-shadow 0.2s;
}
.doc-img-wrap:hover {
    box-shadow: 0 4px 12px rgba(64,158,255,0.2);
}
.doc-img {
    width: 220px;
    height: 140px;
    object-fit: cover;
    display: block;
    transition: transform 0.25s;
}
.doc-img-wrap:hover .doc-img {
    transform: scale(1.03);
}
.doc-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 24px;
    transition: background 0.2s;
    opacity: 0;
}
.doc-img-wrap:hover .doc-overlay {
    background: rgba(0,0,0,0.3);
    opacity: 1;
}
.doc-label {
    font-size: 13px;
    color: #409EFF;
    font-weight: 500;
}

/* avatar uploader */
.avatar-uploader >>> .el-upload {
    border: none;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: block;
}
</style>